module.exports = __webpack_public_path__ + "img/GR016.345924b7.png";